import { uniqueId } from 'lodash';
import { BLANK_CONDITION } from '../../constants';

export const createBlankCondition = () => ({
  ...BLANK_CONDITION,
  id: uniqueId(),
});
